import VirtualAccountProxy from "@/proxies/back-end/business-account/virtual-accounts";

import { Constants } from "customer-sdk/constants";
const { SET_SBA_STATUS } = Constants.PUBLIC_SBA_CONSTANTS;
function initialState() {
  return {
    sbaStatus: {},
  };
}

const state = initialState;

const getters = {};

const actions = {
  GET_SBA_STATUS() {
    const proxy = new VirtualAccountProxy();
    return proxy.checkBusinessAccountProcessStatus();
  },
  SET_SBA_STATUS({ commit }, payload) {
    commit(SET_SBA_STATUS, payload);
  },
};

const mutations = {
  SET_SBA_STATUS(state, payload) {
    state.sbaStatus = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
